<template>
	<div class="bg-white rounded-md p-4 mb-3" :class="[{'isLoading' : isLoading}]">
		<div class="flex items-center mb-3" @click="() => emit('viewGoal', newGoal)">

			<div class="flex-1 flex items-center h-[35px] overflow-clip whitespace-nowrap  transition-all duration-200  max-w-0" >
				<span class="flex-1">
					Assigned Users
				</span>

				<button @click="() => updateAssignedUser()">
					<church-icon class="!w-5 !h-5 !text-black ml-2" icon="x-mark"></church-icon>
				</button>
			</div>

			<div class="flex-1 h-[35px] ml-auto flex items-center max-w-full " >
				<div class="flex-1 w-full font-bold">{{title || newGoal?.post_title || ''}}</div>
	
				<div class="flex" @click="() => updateAssignedUser()">
					<div  class="rounded-full overflow-clip border border-white bg-white" :class="[{ '-ml-4': n != 0 }]" v-for="(user, n) in assignedUsers || []" :key="n">
						<church-icon class="!w-8 !h-8 " v-if="!user?.avatar" icon="person-circle-fill"></church-icon>
						<img v-else class="w-8 h-8 object-fit " :src="user?.avatar" alt="">
					</div>
				
					<span
						v-if="newGoal?.users?.length > 5"
						class="w-8 h-8 rounded-full overflow-clip border border-white -ml-4 bg-gray flex items-center justify-center">5+</span>
				</div>
			</div>

		</div>

		<div>
			<div class="grid grid-cols-1 content-center mb-2">
				<div class="flex items-center">
					<div class="w-full rounded-lg h-1 bg-gray-2 overflow-clip ">
						<div :style="{ width: totalTaskCompleted+'%' }" class="bg-violet h-full rounded-lg"></div>
					</div>
					<div class="text-sm text-center text-gray-1 ml-3">{{totalTaskCompleted}}%</div>
				</div>
			</div>
		</div>


		<div class="max-h-full opacity-100 overflow-clip transition-all duration-150" >
			<m-goal-task-list 
				@toggleComplete="(task) => toggleComplete(task)" 
				@updateTasks="(task) => emit('updateTasks', task)"
				@addMoreTask="() => addMoreTask()" 
				@toDeleteTaskData="(task) => toDeleteTaskData = task" 
				@showDeleteTaskPop="(state) => showDeleteTaskPop = state" 
				:assignedUsers="assignedUsers"
				:goal.sync="localGoal" 
				:completedByName="completedByName" 
				:formatDate="formatDate" 
				:noAddTask="noAddTask" 
				:editMode="editMode" 
				/>
		</div>

        <m-delete-confirmation-pop title="Delete Task" description="Are you sure you want to delete this task?" :showPop="showDeleteTaskPop" @close="() => showDeleteTaskPop = false" @continueDelete="() => removeTask()"/>

		<m-assigned-users-pop 
			:users="users"
			:editMode="editMode" 
			:show.sync="editAssignedUser" 
			:assignedUsers="assignedUsers" 
			@addUser="assignNewUser"
			@removeUser="removeUserFromList" />


	</div>
</template>

<script setup>
/* ============ UTILS ====== */
import GoalApi from '@/apis/goalApis'
import DateUtils from '@/helpers/dateUtls'
import Helper from '@/helpers/helpers'
import store from '@/store'
import {defineProps, defineEmits, onBeforeMount, ref, computed, watch} from 'vue'

/* ======== STATES ======= */
const localGoal = ref({})
const toDeleteTaskData = ref([])
const showDeleteTaskPop = ref(false)
const editAssignedUser = ref(false)

/* ======= PROPS ========= */
const props = defineProps({ 
	newGoal  : {type  : Object, default : () => {}},
	title    : {type : String, default : ''},
	noAddTask: {type : Boolean, default : false},
	editMode : {type : Boolean, default : false},
	isLoading: {type : Boolean, default : false},
	users    : {type : Array, default : () => []}
})

/* ========== EMITS ====== */
const emit = defineEmits(['viewGoal', 'newTask', 'newGoal:update', 'removeTask', 'updateTasks', 'addUser', 'removeUser']) 

/* ======== Computed ========= */

/**
 * Current user
 */
const currentUser = computed(() => store.state.user.user_info || null)

/**
 * Assigned users
 */
const assignedUsers = computed(() => {
	let list = localGoal.value?.users || []
	list = [...list].map(user => {
		const userObj = props.users.find(u => u.ID == user)
		if(userObj) return userObj
		if(user == currentUser.value?.ID) return {
			ID          : currentUser.value.ID,
			id          : currentUser.value.ID,
			avatar      : currentUser.value?.data?.avatar || '',
			display_name: currentUser.value?.data?.display_name || '',
			first_name  : currentUser.value?.data?.user_first_name || '',
			last_name   : currentUser.value?.data?.user_last_name || ''
		}

		return user
	}).filter(user => user)

	console.log('assigned upser goal view item', list)

	return list;
})	



/**
 * Total task completed
 */
const totalTaskCompleted = computed(() => {
	const completed = localGoal.value.tasks.filter(task => task.is_completed).length
	const totalTasks = localGoal.value.tasks.length;
	const percent = totalTasks ? (completed / totalTasks) * 100 : 0;

	return Math.round(percent)
})

/* ============ METHODS ======== */

/**
 * Set goal
 * @param {Object} goal
 */
const setGoal = (goal) => {
	localGoal.value = {...goal}
}

/**
 * Remove user from list
 * @param {Object} user
 */	
const removeUserFromList = (user) => {
	if(!user) return;
	localGoal.value.users = localGoal.value.users.filter(u => u != user.ID)
	emit('newGoal:update', localGoal.value)
	emit('removeUser', user)
}

/**
 * Assign new user
 * @param {Object} user	
 */
const assignNewUser = (user) => {
	if(!user) return;
	localGoal.value.users = [...localGoal.value.users, user.ID]
	emit('newGoal:update', localGoal.value)
	emit('addUser', user)
}

/**
 * Update assigned user
 * 
 */
const updateAssignedUser = () => {
	editAssignedUser.value = !editAssignedUser.value
}

/**
 * Get the name of the user who completed the task
 * @param {Object} task
 */
const completedByName = (task) => {
	if(!task.completed_by) return ''
	const name = `${task?.completed_by?.user_firstname || ''} ${task?.completed_by?.user_lastname || ''}`
	console.log('name', name)
	if(name.trim()) return name
	return task.completed_by.display_name
}

/**
 * Set task complete
 * @param {Object} task	
 */
const toggleComplete = (task) => {
	if(props.editMode) return; // prevent if edit mode is enabled
	if(!task.task_id) return; // prevent if task_id is not available
	if(task.is_completed) return; // prevent if task is already completed
	task.is_completed = true
	task.completed_by = currentUser.value.data
	task.date_completed = DateUtils.dateFormat({date : new Date(), format : 'DD/MM/YYYY'})
	emit('updateTasks', task)

	GoalApi.completeTask({task_id : task.task_id, goal_id : props.newGoal.ID, user_id : currentUser.value.ID})
}	

/**
 * Format date
 * @param {String} date
 */
const formatDate = (date) => {
	return DateUtils.dateFormat({date, format : 'MMMM DD, YYYY', options : {originDateFormat : 'DD/MM/YYYY'}})
}	

/**
 * Add more task
 */
const addMoreTask = () => {
	const params = {
		id: Helper.makeString(5),
		task_name : '',
		is_completed : false
	}
	
	localGoal.value.tasks = [...localGoal.value.tasks, params]
	emit('newTask', params)

}

/**
 * Remove task
 */
const removeTask = () => {
	const tasks = [...localGoal.value.tasks].filter(task => {
		if(toDeleteTaskData.value.id && task.id == toDeleteTaskData.value.id) return false
		if(toDeleteTaskData.value.task_id && task.task_id == toDeleteTaskData.value.task_id) return false

		return task
	})

	localGoal.value.tasks = tasks

	emit('removeTask', toDeleteTaskData.value);

	showDeleteTaskPop.value = false
	
}

/* ============= WATCHER ========= */
/**
 * Watch edit mode changes
 * and reset states
 */
watch(() => props.editMode, (editMode) => {
	if(!editMode) {
		editAssignedUser.value = false
	}
}, {immediate : true})

/* ======== ONLOAD ====== */
onBeforeMount(() => {
	/**
	 * Get goal
	 * 
	 */
	setGoal(props.newGoal)
})

</script>
